import Repository from '../axios'
import {defaultPagination} from "../constants/config";

const  resource = "/admin/departments";
export default {
  get(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getDepartment(departmentId){
    return Repository.get(`${resource}/${departmentId}`)
  },
  updateDepartment(departmentId, payload) {
    return Repository.put(`${resource}/${departmentId}`, payload)
  },
  createDepartment(payload) {
    return Repository.post(`${resource}`, payload)
  }
};
